module.exports = __webpack_public_path__ + "img/trophy.e20749ae.svg";